import Swiper from 'swiper/bundle';

/** Composante Carousel de Timtools */
export default class Carousel {
  /**
   * Méthode constructeur
   * @param {HTMLElement} element - Élément HTML sur lequel la composante est instanciée
   */
  constructor(element) {
    this.element = element;

    // Options par défaut pour la librairie Swiper
    this.defaultOptions = {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: this.element.querySelector('.swiper-pagination'),
        type: 'bullets',
      },
      navigation: {
        nextEl: this.element.querySelector(".swiper-button-next"),
        prevEl: this.element.querySelector(".swiper-button-prev")
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: true
      }
    };

    this.init();
  }

  /**
   * Méthode d'initialisation
   */
  init() {
    let options = this.defaultOptions;

    // Gestion des paramètres différents lorsqu'on veut avoir
    // 2 slides visibles sur grand écran et une seule sur petit écran
    if (this.element.dataset.carousel === 'two') {
      options = {
        ...this.defaultOptions,
        ...{
          slidesPerView: 1,
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
          },
        },
      };
    } else if (this.element.dataset.carousel === 'three') {
      options = {
        ...this.defaultOptions,
        ...{
          slidesPerView: 1.4,
          breakpoints: {
            768: {
              slidesPerView: 2.4,
            },
            1200: {
              slidesPerView: 3,
            },
          },
        },
      };
    } else if (this.element.dataset.carousel === 'four') {
      options = {
        ...this.defaultOptions,
        ...{
          slidesPerView: 1,
          breakpoints: {
            544: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3.4,
            },
            1200: {
              slidesPerView: 4.4,
            },
          },
        },
      };
    } else if (this.element.dataset.carousel === 'five') {
      options = {
        ...this.defaultOptions,
        ...{
          slidesPerView: 1,
          breakpoints: {
            544: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            },
            992: {
              slidesPerView: 4,
            },
            1200: {
              slidesPerView: 5,
            },
          },
        },
      };
    } else if (this.element.dataset.carousel === 'six') {
      options = {
        ...this.defaultOptions,
        ...{
          slidesPerView: 1,
          breakpoints: {
            544: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            },
            992: {
              slidesPerView: 4,
            },
            1200: {
              slidesPerView: 5.4,
            },
            1400: {
              slidesPerView: 6.4,
            },
          },
        },
      };
    } else if (this.element.dataset.carousel === 'dashboard') {
      options = {
        ...this.defaultOptions,
        ...{
          slidesPerView: 1.3,
          breakpoints: {
            800: {
              slidesPerView: 2.3,
            },
            1100: {
              slidesPerView: 3.3,
            },
            1300: {
              slidesPerView: 4.3,
            },
            1600: {
              slidesPerView: 5.3,
            },
            1800: {
              slidesPerView: 6.3,
            },
          },
        },
      };
    }

    // Instanciation d'un nouveau Swiper avec les options
    new Swiper(this.element, options);
  }
}
